import React, { Component } from "react";
import * as XLSX from 'xlsx'
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { SubmitButton, TextBox, formatDate, } from "../../Components/InputElements";
import { Loader, NoRecords } from '../../Components/Shimmer';
import Select from 'react-select'
import { currentDateAndTime, decodeData, getFormatedDate } from "../../Constants/constants";

class ApprovedLeave extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: '',
      employee_leave_id: '',
      selectedImage: null,
      fileName: "",
      fileSize: "",
      errors: {},
      errorMessage: '',
      leave_type_id: '',
      employee_leave_to_day_unit: '',
      employee_leave_from_day_unit: '',
      employee_leave_reason: '',
      employee_leave_from_date: '',
      employee_leave_to_date: '',
      employee_leave_document: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      employee_leave_status: '',
      leave_type_rows: [],
      leave_type_by_emp_rows: [],
      employee_verified_row: [],
      reportrows: [],
      log_rows: [],
      filter_leave_type_id: '',
      leave_category_id: '',
      required_document: 0,
      leave_loader: false,
      past_days: 0,
      half_day: 0,
      leave_log_rows: [],
      check_modal_type: '',
      LeaveRows: [],
      get_url: '',
      employee_info: [],
      submitAttempted: false,
      salaries: [],
      salaries_statutory: [],
      weekenddays: [],
      festivals: [],
      selectedRows: [],
      loadingLeave: false,
      decodedData: [],
      admin_access_leave_module:"0"
      
    };

    this.modalRef = React.createRef();
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetLeaveTypeList();
      this.GetEmployeesVerifiedList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  validateNotEmpty = (fieldName, value) => {
    if (value === undefined || value === null) {
      return `${fieldName} is required`;
    }
    if (typeof value !== 'string') {
      value = String(value);
    }
    if (value.trim() === '') {
      return `${fieldName} is required`;
    }
    return '';
  }


  CheckSelectWeekend = (FromDate, ToDate) => {
    if (!FromDate || !ToDate) {
      return false;
    }

    const weekenddays = this.state.weekenddays;

    const fromDate = new Date(FromDate);
    const toDate = new Date(ToDate);

    if (isNaN(fromDate) || isNaN(toDate)) {
      console.error('Invalid date format in CheckSelectWeekend');
      return false;
    }

    const dayOfWeekMap = {
      0: "Sunday",
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday"
    };

    const isWeekendDay = (date) => {
      const dayOfWeek = dayOfWeekMap[date.getUTCDay()];
      return weekenddays.some(weekend => weekend.shift_day === dayOfWeek);
    };

    if (isWeekendDay(fromDate) && isWeekendDay(toDate)) {
      Swal.fire({
        title: 'Error',
        text: 'You cannot apply leave on your week off',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return true;
    }

    return false;
  };

  CheckSelectFestival = (FromDate, ToDate) => {
    if (!FromDate || !ToDate) {
      return false;
    }

    const festivals = this.state.festivals;

    const fromDate = new Date(FromDate);
    const toDate = new Date(ToDate);

    if (isNaN(fromDate) || isNaN(toDate)) {
      console.error('Invalid date format in CheckSelectFestival');
      return false;
    }

    const isFestivalDay = (date) => {
      const formattedDate = date.toISOString().split('T')[0];
      return festivals.some(festival => festival.calendar_festival_date === formattedDate);
    };

    if (isFestivalDay(fromDate) || isFestivalDay(toDate)) {
      Swal.fire({
        title: 'Error',
        text: 'You can not apply leave on holiday',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return true;
    }

    return false;
  };


  validateDate = (fieldName, value_to, value_from) => {
    if (!value_to || !value_from) {
      return '';
    }

    const date = new Date(value_to);
    const today = new Date(value_from);

    if (isNaN(date) || isNaN(today)) {
      console.error('Invalid date format in validateDate');
      return `Invalid date format in ${fieldName}`;
    }

    if (date < today) {
      return `Please Select Future Date In ${fieldName}....!!`;
    }
    return '';
  }


  GetLeaveTypeInfo = (leave_type_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetLeaveTypeInfo`, { params: { leave_type_id: leave_type_id }, headers }).then((response) => {
      var data = response.data.data;
      if (response.data.success === true) {
        this.setState({
          required_document: data[0].required_document,
          half_day: data[0].half_day,
          future_days: data[0].future_days,
          past_days: data[0].past_days,
          loadingList: false,
        });
      } else {
        this.setState({ loadingList: false });
      }
    });
  }

  GetAssignShift = (employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetAssignShift`, { params: { employee_id: employee_id }, headers }).then((response) => {
      var data = response.data.data;
      var festivals = response.data.festivals;
      if (response.data.success === true) {
        this.setState({
          weekenddays: data,
          festivals: festivals,
          loadingList: false,
        });
      } else {
        this.setState({ loadingList: false });
      }
    });
  }

  GetLeaveLogs = (employee_leave_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetLeaveLogs`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
      var data = response.data;
      this.setState({ leave_log_rows: [] });
      if (response.data.success === true) {
        this.setState({
          leave_log_rows: data.data,
          loadingList: false
        });
      } else {
        this.setState({ loadingList: false });
      }
    });
  }

  CheckValidation = () => {
    const errors = {};
    const {
      employee_leave_from_date,
      employee_leave_to_date,
      employee_leave_reason,
      leave_type_id,
      employee_leave_from_day_unit,
      employee_leave_to_day_unit,
      half_day,
      employee_id,
    } = this.state;

    errors.employee_leave_from_date = this.validateNotEmpty('From Date', employee_leave_from_date);
    errors.employee_leave_to_date = this.validateNotEmpty('To Date', employee_leave_to_date) || this.validateDate('To Date', employee_leave_to_date, employee_leave_from_date);
    errors.employee_leave_reason = this.validateNotEmpty('Reason', employee_leave_reason);
    errors.leave_type_id = this.validateNotEmpty('Leave Type', leave_type_id);
    errors.employee_id = this.validateNotEmpty('Employee', employee_id);
    errors.employee_leave_from_day_unit = this.validateNotEmpty('From Date Unit', employee_leave_from_day_unit);
    errors.employee_leave_to_day_unit = this.validateNotEmpty('To Date Unit', employee_leave_to_day_unit);

    const weekendError = this.CheckSelectWeekend(employee_leave_from_date, employee_leave_to_date);
    const festivalError = this.CheckSelectFestival(employee_leave_from_date, employee_leave_to_date);

    if (weekendError === true || festivalError === true) {
      errors.weekendError = "weekendError";
      errors.festivalError = "festivalError";
    }

    // Your validation logic for past and future dates
    const minDate = this.calculateMinDate();
    const maxDate = this.calculateMaxDate();

    if (employee_leave_from_date && new Date(employee_leave_from_date) < new Date(minDate)) {
      errors.employee_leave_from_date = `This leave type allows to apply till ${formatDate(minDate)}`;
    }
    if (employee_leave_to_date && new Date(employee_leave_to_date) > new Date(maxDate)) {
      errors.employee_leave_to_date = `This leave type allows to apply till ${formatDate(maxDate)}`;
    }

    if (employee_leave_from_date === employee_leave_to_date &&
      employee_leave_from_day_unit !== employee_leave_to_day_unit) {
      errors.employee_leave_to_day_unit = 'Please select same unit as From Day unit';
    }

    if (half_day === 0 && employee_leave_from_day_unit !== "Full Day") {
      errors.employee_leave_from_day_unit = 'This leave type does not allow half day, please select full day';
    }
    if (half_day === 0 && employee_leave_to_day_unit !== "Full Day") {
      errors.employee_leave_to_day_unit = 'This leave type does not allow half day, please select full day';
    }

    return errors;
  }


  handleSubmit = (isUpdate) => {
    const errors = this.CheckValidation();
    const fileInput = document.getElementById("employee_leave_document");
    const file = fileInput ? fileInput.files[0] : null;

    if (this.state.required_document !== 0 && !file) {
      errors.required_document = `Document Is required...!`;
    }

    this.setState({ errors, leave_loader: true }, () => {
      if (Object.values(errors).every(error => error === '')) {
        const formData = new FormData();
        formData.append("employee_id", this.state.employee_id);
        formData.append("leave_type_id", this.state.leave_type_id);
        formData.append("employee_leave_from_date", this.state.employee_leave_from_date);
        formData.append("employee_leave_to_date", this.state.employee_leave_to_date);
        formData.append("employee_leave_reason", this.state.employee_leave_reason);
        formData.append("employee_leave_to_day_unit", this.state.employee_leave_to_day_unit);
        formData.append("employee_leave_from_day_unit", this.state.employee_leave_from_day_unit);
        formData.append("required_document", this.state.required_document);

        if (isUpdate === true) {
          formData.append("employee_leave_id", this.state.employee_leave_id);
        }
        if (file) {
          formData.append("employee_leave_document", file);
        }

        var headers = this.context.apiHeaderFile;
        const { apiURL } = this.context;
        axios.post(`${apiURL}Employees/CreateApplyLeave`, formData, { headers })
          .then((response) => {
            if (response.data.success === true) {
              Swal.fire({
                title: `<strong>${response.data.message}</strong>`,
                icon: 'success',
              });
              this.closeRef.current.click();
              this.setState({ leave_loader: false });
              this.resetForm();
              this.GetList();
              this.GetRemmainingLeaves();
            } else {
              Swal.fire({
                title: `<strong>${response.data.message}</strong>`,
                icon: 'warning',
              });
              this.setState({ leave_loader: false });
            }
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            this.setState({ leave_loader: false });
          });
      } else {
        this.setState({ leave_loader: false });
        console.log("Form submission failed due to errors:", errors);
      }
    });
  };


  GetEmployeesVerifiedList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_verified_row: data.data.map((row) => ({
              value: row.employee_id,
              label: row.employee_name
            }))
          }));
        }
      });
  }

  GetLeaveTypeList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLeaveTypeList`, { headers })
      .then((response) => {
        var data = response.data;

        if (response.data.success === true) {
          this.setState((prevState) => ({
            leave_type_rows: data.data.map((row) => ({
              value: row.leave_type_id,
              label: row.leave_type_name
            }))
          }));
        }
      });
  }

  GetLeaveTypeListByEmp = (employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLeaveTypeList?employee_id=${employee_id}`, { headers })
      .then((response) => {
        var data = response.data.remaining_leaves;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            leave_type_by_emp_rows: data.map((row) => ({
              value: row.leave_type_id,
              label: (
                <span>
                  {row.leave_name}
                  <strong className="mx-2">(Blc : {row.remaining_leaves})</strong>
                </span>
              ),
            }))
          }));
        }
      });
  }

  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios.get(`${apiURL}Masters/GetPendingLeaves`, {
      params: {
        limit: this.state.limit,
        page: this.state.page,
        keyword: this.state.keyword,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        employee_leave_status: this.state.selectOption,
        leave_type_id: this.state.filter_leave_type_id,
        date: currentDateAndTime(),
      },
      headers,
    })
      .then((response) => {

        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            admin_access_leave_module: data?.admin_access_leave_module
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  GetLeaveReports = (employee_leave_id, employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    this.setState({ log_rows: [], });
    axios.get(`${apiURL}Masters/GetEmployeeLeaveReport`, {
      params: {
        employee_leave_id: employee_leave_id,
        employee_id: employee_id,
      },
      headers,
    }).then((response) => {
      var data = response.data;
      if (data.success === true && this.state.log_rows.length === 0) {
        this.setState({
          reportrows: data.data[0],
          log_rows: data.Logs,
          loadingList: false,
        });
      } else {
        this.setState({ loadingList: false });
      }
    });
  };


  LeaveAction = (employee_id, employee_leave_id, accept_reject) => {
    Swal.fire({
      title: 'Submit Remark',
      input: 'text',
      inputPlaceholder: 'Enter your Remark',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'Remark cannot be empty';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        var formData = {
          employee_leave_status: accept_reject,
          date: currentDateAndTime(),
        };

        if (this.state.selectedRows.length !== 0) {
          formData.employee_id = JSON.stringify(this.state.selectedRows);
          formData.type = "bulk";
        } else {
          formData.employee_leave_id = employee_leave_id;
          formData.employee_id = employee_id;
        }

        if (result.value) {
          formData.remark = result.value;
        } else {
          formData.remark = '';
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.post(`${apiURL}Masters/AcceptedOrRejectedLeaves`, formData, { headers })
          .then((response) => {
            this.setState({ selectedRows: [] });
            Swal.fire({
              title: `<strong>${response.data.message}</strong>`,
              icon: 'success',
            });
            this.GetList();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    });
  };


  resetForm = () => {
    this.setState({
      employee_leave_id: 0,
      leave_type_id: '',
      employee_id: '',
      employee_leave_from_date: '',
      employee_leave_to_date: '',
      employee_leave_document: '',
      employee_leave_reason: '',
      employee_leave_to_day_unit: '',
      employee_leave_from_day_unit: '',
      fileName: "",
      fileSize: "",
    });
  }


  resetemployee_leave_document = () => {
    // Clear the input value
    const employee_leave_document = document.getElementById("employee_leave_document");
    if (employee_leave_document) {
      employee_leave_document.value = null;
    }
    // Keep the same key for the input
    let randomString = Math.random().toString(36);
    this.setState({
      theInputKey: randomString,
    });
  };



  handleFileChange = (e) => {
    const file = e.target.files[0];
    const { errors } = this.state;
    if (file) {
      const { name, size, type } = file;
      const fileSizeInMB = size / (1024 * 1024);
      errors.required_document = '';
      if (fileSizeInMB > 10) {
        errors.required_document = 'File size exceeds the maximum limit of 10 MB';
        console.error("File size exceeds the maximum limit of 10 MB");
        return;
      }
      errors.required_document = '';
      let newState = {
        fileName: name,
        fileSize: `${fileSizeInMB.toFixed(2)} MB`,
        letterhead: [file],
      };

      if (type.startsWith("image/")) {
        newState = {
          ...newState,
          selectedImage: URL.createObjectURL(file),
          fileTypeIcon: "ri-image-fill",
        };
      } else {
        newState = {
          ...newState,
          isValidPdfFile: true,
          fileTypeIcon: "ri-file-pdf-fill",
        };
      }
      this.setState(newState);
      this.setState({ errors });
    }
  };

  handleDeleteImage = () => {
    this.setState({
      selectedImage: null,
      fileName: "",
      fileSize: "",

    });
    this.resetemployee_leave_document();
  };

  GetLeaveInfo = (employee_leave_id, employee_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios.get(`${apiURL}Employees/GetLeaveInfo`, { params: { employee_leave_id: employee_leave_id, employee_id: employee_id }, headers }).then((response) => {
      const { data, success } = response.data;
      this.setState({ get_url: '' });
      if (success === true) {

        this.setState(
          {
            leave_type_id: data[0].leave_type_id,
            employee_id: data[0].employee_id,
            employee_leave_from_date: data[0].employee_leave_from_date,
            employee_leave_to_date: data[0].employee_leave_to_date,
            employee_leave_document: data[0].employee_leave_document,
            employee_leave_reason: data[0].employee_leave_reason,
            employee_leave_from_day_unit: data[0].employee_leave_from_day_unit,
            employee_leave_to_day_unit: data[0].employee_leave_to_day_unit,
            get_url: data[0].employee_leave_document_url,
          }
        )
      }
    });
  }

  handleCheckModalType = (CheckModalType, employee_leave_id, employee_id) => {
    if (CheckModalType === 0) {
      this.resetForm();
      this.setState({
        check_modal_type: CheckModalType,
        submitAttempted: false,
        get_url: '',
        employee_leave_id: 0,
        errors: {},
      });
    }
    else if (CheckModalType === 1) {
      this.setState({
        check_modal_type: CheckModalType,
        employee_leave_id: employee_leave_id,
        submitAttempted: false,
        errors: {},
      });
      this.GetLeaveInfo(employee_leave_id, employee_id);
    }
    else if (CheckModalType === 2) {
      this.setState({
        check_modal_type: CheckModalType,
        submitAttempted: false,
        errors: {},
      });
      this.GetLeaveInfo(employee_leave_id);
      this.GetLeaveLogs(employee_leave_id);
    }
  }

  // handleExcelDownload = () => {
  //   const { apiURL, apiHeaderJSON } = this.context;
  //   const headers = apiHeaderJSON;

  //   Swal.fire({
  //     title: 'Please wait...',
  //     html: 'Your file is being prepared for download.',
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       Swal.showLoading();
  //     }
  //   });

  //   axios.get(`${apiURL}Masters/GetPendingLeaves`, {
  //     params: {
  //       limit: this.state.total_records,
  //       page: 1,
  //       keyword: this.state.keyword,
  //       from_date: this.state.from_date,
  //       to_date: this.state.to_date,
  //       employee_leave_status: this.state.selectOption,
  //       leave_type_id: this.state.filter_leave_type_id,
  //     },
  //     headers,
  //   }).then((response) => {
  //     if (response.data.success === true) {
  //       const rows = response.data.data;

  //       const data = rows.map(row => ({
  //         'Employee Code': row.employee_code,
  //         'Employee Name': row.employee_name,
  //         'Application Date': formatDate(row.leave_application_date),
  //         'Leave Type': row.heads_labels[0].concatenated_data,
  //         'From Date': formatDate(row.employee_leave_from_date),
  //         'To Date': formatDate(row.employee_leave_to_date),
  //         'Duration': row.employee_leave_days + (row.employee_leave_days <= 1 ? " day" : " days"),
  //         'Status': row.employee_leave_status_label,
  //       }));


  //       const columns = [
  //         { header: 'Employee Code', key: 'Employee Code', width: 20 },
  //         { header: 'Employee Name', key: 'Employee Name', width: 20 },
  //         { header: 'Application Date', key: 'Application Date', width: 20 },
  //         { header: 'Leave Type', key: 'Leave Type', width: 20 },
  //         { header: 'From Date', key: 'From Date', width: 20 },
  //         { header: 'To Date', key: 'To Date', width: 20 },
  //         { header: 'Duration', key: 'Duration', width: 20 },
  //         { header: 'Status', key: 'Status', width: 20 },
  //       ];


  //       const wb = XLSX.utils.book_new();


  //       const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


  //       ws['!cols'] = columns.map(column => ({ wch: column.width }));


  //       XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


  //       columns.forEach((column, index) => {
  //         ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
  //       });


  //       XLSX.utils.book_append_sheet(wb, ws, 'AbStart Leave Report');


  //       XLSX.writeFile(wb, `Leave Report ${getFormatedDate()}.xlsx`);


  //       Swal.close();


  //       Swal.fire({
  //         title: '<strong>Success</strong>',
  //         html: 'Your file has been downloaded successfully.',
  //         icon: 'success'
  //       });
  //     } else {

  //       Swal.close();

  //       Swal.fire({
  //         title: '<strong>Error</strong>',
  //         html: response.data.message,
  //         icon: 'error'
  //       });
  //     }
  //   })
  //     .catch((error) => {
  //       // Close the Swal alert if there is an error
  //       Swal.close();

  //       Swal.fire({
  //         title: '<strong>Error</strong>',
  //         html: error.message,
  //         icon: 'error'
  //       });
  //     });
  // }

  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
      title: 'Please wait...',
      html: 'Your file is being prepared for download.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    axios.get(`${apiURL}Masters/GetPendingLeaves`, {
      params: {
        limit: this.state.total_records,
        page: 1,
        keyword: this.state.keyword,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        employee_leave_status: this.state.selectOption,
        leave_type_id: this.state.filter_leave_type_id,
        export_data: true, 
        date: currentDateAndTime()
      },
      headers,
    }).then((response) => {
      if (response.data.success === true) {
        const rows = response.data.data;

        const data = rows.map(row => ({
          'Employee Code': row.employee_code || "--",
          'Employee Name': row.employee_name || "--",
          'Application Date': row.leave_application_date && formatDate(row.leave_application_date),
          'Leave Type': Array.isArray(row.heads_labels) && row.heads_labels?.length>0 ? row.heads_labels[0].concatenated_data || "--" : '--',
          'From Date': row.employee_leave_from_date && formatDate(row.employee_leave_from_date),
          'To Date': row.employee_leave_to_date && formatDate(row.employee_leave_to_date),
          'Before Balance': row?.employee_leave_balance_before,
          'Duration': row.employee_leave_days + (row.employee_leave_days <= 1 ? " day" : " days"),
          'After Balance': row?.employee_leave_balance_after,
          'Status': row.employee_leave_status_label,
        }));

        const columns = [
          { header: 'Employee Code', key: 'Employee Code', width: 20 },
          { header: 'Employee Name', key: 'Employee Name', width: 20 },
          { header: 'Application Date', key: 'Application Date', width: 20 },
          { header: 'Leave Type', key: 'Leave Type', width: 20 },
          { header: 'From Date', key: 'From Date', width: 20 },
          { header: 'To Date', key: 'To Date', width: 20 },
          { header: 'Before Balance', key: 'Before Balance', width: 15 },
          { header: 'Duration', key: 'Duration', width: 10 },
          { header: 'After Balance', key: 'After Balance', width: 15 },
          { header: 'Status', key: 'Status', width: 20 },
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
        ws['!cols'] = columns.map(column => ({ wch: column.width }));

        XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });

        columns.forEach((column, index) => {
          ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
        });

        XLSX.utils.book_append_sheet(wb, ws, 'AbStart Leave Report');
        XLSX.writeFile(wb, `Leave Report ${getFormatedDate()}.xlsx`);

        Swal.close();

        Swal.fire({
          title: '<strong>Success</strong>',
          html: 'Your file has been downloaded successfully.',
          icon: 'success'
        });
      } else {
        Swal.close();
        Swal.fire({
          title: '<strong>Error</strong>',
          html: response.data.message,
          icon: 'error'
        });
      }
    })
    .catch((error) => {
      Swal.close();
      Swal.fire({
        title: '<strong>Error</strong>',
        html: error.message,
        icon: 'error'
      });
    });
};

handleLeaveExcelDownload = async () => {
  const { apiURL, apiHeaderJSON } = this.context;
  const headers = apiHeaderJSON;
  const data = {
    activated: "1",
    LeaveBalance: true ,
    date: currentDateAndTime(),
  }
  console.log("ExportEmployeeLeaveDataToExcel => formData",data);
  console.log("ExportEmployeeLeaveDataToExcel => formData",data.date);
  Swal.fire({
      title: 'Please wait...',
      html: 'Your file is being prepared for download.',
      allowOutsideClick: false,
      didOpen: () => {
          Swal.showLoading();
      }
  });
  axios.post(`${apiURL}Employees/ExportEmployeeLeaveDataToExcel`, data, {
      headers
  })
  .then(async (response) => {
      const { success, employee_leave_data, message } = response.data;

      if (success === true) {
          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Function to create worksheet for a category
          const createWorksheet = (dataArray, sheetName) => {
              const worksheetArray = [];

              // If it's a 2D array, map each sub-array
              if (Array.isArray(dataArray[0])) {
                  dataArray.forEach(subArray => {
                      worksheetArray.push(subArray);
                  });
              } else {
                  // Otherwise, just use the single array
                  worksheetArray.push(dataArray);
              }

              const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
              XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
          };

          // Leave Balance Sheet
          if (employee_leave_data.LeaveBalance) {
              createWorksheet(employee_leave_data.LeaveBalance, 'LeaveBalance');
          }

          const file_name = `Employee Leave Balance.xlsx`;

          // Write the workbook to an Excel file
          XLSX.writeFile(workbook, file_name);

          Swal.close();
          Swal.fire({
              title: `<strong>Success</strong>`,
              text: message,
              icon: 'success',
              showConfirmButton: true
          });
      } else {
          Swal.close();
          Swal.fire({
              title: `<strong>Failed</strong>`,
              text: message,
              icon: 'error',
              showConfirmButton: true
          });
      }

  })
  .catch((error) => {
      Swal.close();
      Swal.fire({
          title: `<strong>Failed</strong>`,
          text: error.response ? error.response.message : error.message,
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false,
      });
  });
  };

  calculateMinDate() {
    const today = new Date();
    const pastDays = this.state.past_days;
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - pastDays);

    const year = pastDate.getFullYear();
    const month = String(pastDate.getMonth() + 1).padStart(2, '0');
    const day = String(pastDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  calculateMaxDate() {
    const today = new Date();
    const futureDays = this.state.future_days;
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + futureDays);

    const year = futureDate.getFullYear();
    const month = String(futureDate.getMonth() + 1).padStart(2, '0');
    const day = String(futureDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  handleInputSearch = () => {
    this.GetList();
    this.setState({ selectedRows:[]});
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleSelectChange(name, selectedOption) {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }), () => {
      if (name === 'employee_id') {
        this.GetAssignShift(selectedOption.value);
        this.GetLeaveTypeListByEmp(selectedOption.value);
      }
      if (name === 'leave_type_id') {
        this.GetLeaveTypeInfo(selectedOption.value);
      }
    });
  }

  // handleSelectAll = () => {
  //   this.setState((prevState) => {
  //     const selectedRows = prevState.selectedRows.length === prevState.rows.length 
  //       ? []
  //       : prevState.rows.map((row) =>{
  //         return { employee_id: row?.employee_id, employee_leave_id: row?.employee_leave_id }
  //       });

  //     return { selectedRows };
  //   });
  // };

  handleSelectAll = () => {
    this.setState((prevState) => {
      console.log("Rows Data:", prevState.rows);
  
      const eligibleRows = prevState.rows.filter(row => row.employee_leave_status == "0");
  
      console.log("Eligible Rows (status '0'):", eligibleRows);
  
      const selectedRows = prevState.selectedRows.length === eligibleRows.length
        ? []  
        : eligibleRows.map((row) => {
            return { employee_id: row?.employee_id, employee_leave_id: row?.employee_leave_id };
          });
  
      console.log("Selected Rows:", selectedRows);
  
      return { selectedRows };
    });
  };
  
  

  
  handleCheckboxChange = (employeeId, employeeLeaveId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];
      const index = selectedRows.findIndex(row => row.employee_id === employeeId && row.employee_leave_id === employeeLeaveId);

      if (index > -1) {
        selectedRows.splice(index, 1);
      } else {
        selectedRows.push({ employee_id: employeeId, employee_leave_id: employeeLeaveId });
      }
      console.log(`selectedRows`, selectedRows);
      return { selectedRows };
    });
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };

  handleClearAll = () => {
    this.setState(
      {
        filter_leave_type_id: '',
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        keyword: "",
        from_date: "",
        to_date: "",
        selectOption: "",
        selectedRows:[],
      },
      () => {
        this.GetList();
      }
    );
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const { reportrows, log_rows, errors, } = this.state;
    const UnitOptions = [
      { value: 'First Half', label: 'First Half' },
      { value: 'Second Half', label: 'Second Half' },
      { value: 'Full Day', label: 'Full Day' }
    ];

    const options = [
      { value: '0', label: 'Pending' },
      { value: '2', label: 'Approved' },
      { value: '1', label: 'Rejected' },
      { value: '3', label: 'Canceled' },
    ];

    return (
      this.state.loadingList = true ?
        (<div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <br />
              <PageTitle title={`Leave Reports`} primary={`Home`} />
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                      
                        <div className='col-md-3'>
                         
                          <label htmlFor="keyword">Enter name</label>
                          <div className="input-group">
                            <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                            <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                          </div>
                        </div>
                    
                        <div className='col-md-3'>
                          <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3'>
                          <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3 position-relative'>
                          <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                            <div><label>Status</label></div>
                            <Select
                              options={options}
                              value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}
                              onChange={(selectedOption) => this.handleSelectChange('selectOption', selectedOption)}
                              placeholder={`Select Status`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className='col-md-3 position-relative'>
                          <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                            <div><label>Leave Type</label></div>
                            <Select
                              onChange={(selectedOption) => this.handleSelectChange('filter_leave_type_id', selectedOption)}
                              placeholder={`Select Leave Type`}
                              options={this.state.leave_type_rows}
                              value={this.state.filter_leave_type_id ? this.state.leave_type_rows.find((option) => option.value === this.state.filter_leave_type_id) : null} // Add this line
                            />
                          </div>
                        </div>
                        <div className='col-md-3'>
                          <div className="row">
                            <div className='col-md-6'>
                              <div>
                                <label>Apply Filter</label>
                              </div>
                              <button
                                type="button"
                                onClick={this.handleInputSearch}
                                // disabled={this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === ''}
                                className={`w-100 btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                Filter
                              </button>
                            </div>
                            <div className='col-md-6'>
                              <div>
                                <label className=" noWrap">Show All</label>
                              </div>
                              <button
                                type="button"
                                className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                onClick={this.handleClearAll}
                              >
                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Show All</button>
                            </div>

                          </div>

                        </div>
                        {(this.state.decodedData?.includes(6)) && (
                        <div className='col-md-3'>
                          <div className="row">
                            <div className='col-md-12'>
                              <div>
                                <label>Export Excel</label>
                              </div>
                              <button
                                type="button"
                                onClick={this.handleExcelDownload}
                                className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light`}>
                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                Export Excel
                              </button>
                            </div>
                          </div>
                        </div>)}
                        {this.state.selectedRows.length !== 0 && this.state.decodedData?.includes(3) ?
                          (<div className='col-md-3'>
                            <div className="row">
                              <div className='col-md-6'>
                                <div>
                                  <label>Approve leave</label>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => this.LeaveAction(0, 0, 2)}
                                  className={`btn btn-success btn-label waves-effect waves-light `}>
                                  <i className="bx bx-check-circle label-icon align-middle fs-20 me-2"></i>
                                  Approve
                                </button>
                              </div>
                              <div className='col-md-6'>
                                <div>
                                  <label>Reject Leave</label>
                                </div>
                                <button
                                  type="button"
                                  className={`btn btn-danger btn-label waves-effect waves-light`}
                                  onClick={() => this.LeaveAction(0, 0, 1)}
                                >
                                  <i className="bx bx-x-circle label-icon align-middle fs-20 me-2"></i>
                                  Reject
                                </button>
                              </div>
                            </div>

                          </div>) : ""
                        }
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                      <div className="col-md-12 ">
                        <div style={{ float: "right", marginRight: "18px" }}>
                          {/* {localStorage.getItem("company_id_erp") != 3 ? */}
                          {(this.state.decodedData?.includes(6)) && (  
                            <SubmitButton buttonName='Leave balance' otherClasses='me-3' onClick={this.handleLeaveExcelDownload} icon={"ri-file-excel-line"} type='success' />)}
                          {(this.state.decodedData?.includes(2)) && (  
                            <button type="button"
                              onClick={() => this.handleCheckModalType(0, 0)}
                              className="btn btn-success btn-label waves-effect waves-light"
                              data-bs-toggle="modal" data-bs-target="#myModal">
                              <i className="bx bx-add-to-queue label-icon align-middle fs-16 me-2" />
                              Apply Leave</button>)}

                          <div id="myModal" ref={this.modalRef} className="modal fade" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true" style={{ display: 'none' }}>
                            <div className={`modal-dialog ${this.state.check_modal_type === 2 ? ('modal-xl') : "modal-lg"} `}>
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="myModalLabel">Leaves</h5>
                                  <button type="button" ref={this.closeRef} className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.resetForm}> </button>
                                </div>
                                <div className="modal-body">
                                  <form className="row">
                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="employee_id" className="form-label">Select Employee:</label>
                                      <Select
                                        onChange={(selectedOption) => this.handleSelectChange('employee_id', selectedOption)}
                                        placeholder={`Select Employee`}
                                        options={this.state.employee_verified_row}
                                        value={this.state.employee_verified_row.find(option => option.value === this.state.employee_id) || null}
                                        isDisabled={this.state.check_modal_type === 1}
                                      />
                                      {errors.employee_id && <div className="text-danger">{errors.employee_id}</div>}
                                    </div>
                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="leave_type_id" className="form-label">Select Leave Type:</label>
                                      <Select
                                        onChange={(selectedOption) => this.handleSelectChange('leave_type_id', selectedOption)}
                                        placeholder={`Select Leave Type`}
                                        options={this.state.leave_type_by_emp_rows}
                                        value={this.state.leave_type_by_emp_rows.find(option => option.value === this.state.leave_type_id) || null}
                                        isDisabled={this.state.check_modal_type === 1 || !this.state.employee_id} />
                                      {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                    </div>

                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="employee_leave_from_date"><span>From Date</span></label>
                                      <input
                                        type="date"
                                        id="employee_leave_from_date"
                                        name="employee_leave_from_date"
                                        disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id || !this.state.employee_id}
                                        value={this.state.employee_leave_from_date}
                                        className='form-control'
                                        onChange={this.handleInputChange}
                                      />

                                      {errors.employee_leave_from_date && <div className="text-danger">{errors.employee_leave_from_date}</div>}

                                    </div>
                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="employee_leave_from_day_unit" className="form-label">Form Date Unit:</label>
                                      <Select
                                        id="employee_leave_from_day_unit"
                                        name="employee_leave_from_day_unit"
                                        value={UnitOptions.find(option => option.value === this.state.employee_leave_from_day_unit) || null}
                                        onChange={(selectedOption) => this.handleSelectChange('employee_leave_from_day_unit', selectedOption)}
                                        options={UnitOptions}
                                        placeholder="Select from date unit"
                                        required
                                        isDisabled={this.state.check_modal_type === 2 || !this.state.leave_type_id || !this.state.employee_id}
                                      />
                                      {errors.employee_leave_from_day_unit && <div className="text-danger">{errors.employee_leave_from_day_unit}</div>}

                                    </div>


                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="employee_leave_to_date"><span>To Date</span></label>
                                      <input type="Date" id="employee_leave_to_date" name="employee_leave_to_date" value={this.state.employee_leave_to_date} className='form-control' disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id} onChange={this.handleInputChange} />
                                      {errors.employee_leave_to_date && <div className="text-danger">{errors.employee_leave_to_date}</div>}
                                    </div>

                                    <div className="col-md-6 mt-3">
                                      <label htmlFor="employee_leave_to_day_unit" className="form-label">TO Date Unit:</label>
                                      <Select
                                        id="employee_leave_to_day_unit"
                                        name="employee_leave_to_day_unit"
                                        value={UnitOptions.find(option => option.value === this.state.employee_leave_to_day_unit) || null}
                                        onChange={(selectedOption) => this.handleSelectChange('employee_leave_to_day_unit', selectedOption)}
                                        options={UnitOptions}
                                        placeholder="Select to date unit"
                                        required
                                        isDisabled={this.state.check_modal_type === 2 || !this.state.leave_type_id || !this.state.employee_id}
                                      />
                                      {errors.employee_leave_to_day_unit && <div className="text-danger">{errors.employee_leave_to_day_unit}</div>}
                                    </div>
                                    <div className="col-md-12 mt-3">
                                      <label>Reason</label>
                                      <textarea
                                        type='text'
                                        rows={3}
                                        className='form-control'
                                        id='employee_leave_reason'
                                        name='employee_leave_reason'
                                        value={this.state.employee_leave_reason}
                                        disabled={this.state.check_modal_type === 2 || !this.state.leave_type_id || !this.state.employee_id}
                                        label='Reason'
                                        placeholder='Enter Reason'
                                        onChange={this.handleInputChange} />
                                      {errors.employee_leave_reason && <div className="text-danger">{errors.employee_leave_reason}</div>}
                                    </div>
                                    <div className="col-md-12 mt-3">
                                      <a href={`${this.state.get_url}`}
                                        className={`${!this.state.get_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                        style={{ marginTop: "10px", float: 'right' }}
                                        target="_blank" rel="noopener noreferrer">
                                        {/* <i className="ri-eye-fill label-icon align-middle fs-16 me-2" /> */}
                                        View Uploaded Document
                                      </a>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                      <div className="card-body">
                                        <div>
                                          <label htmlFor="employee_leave_document" className="form-label">Attachment<span className='text-muted '>{this.state.required_document === 0 ? ("(...Optional)") : "(...Requested)"}</span></label>
                                          <input
                                            type="file"
                                            id="employee_leave_document"
                                            key={this.state.theInputKey || ""}
                                            onChange={this.handleFileChange}
                                            style={{ marginTop: "10px", display: "none" }}
                                            accept="image/jpeg, image/png, application/pdf"
                                            disabled={this.state.check_modal_type === 2}
                                          />

                                          <div className="d-flex justify-content-between mt-3">
                                            <label
                                              type="submit"
                                              className="btn btn-primary btn-label waves-effect waves-light"
                                              style={{ marginTop: "10px" }}
                                              htmlFor="employee_leave_document"
                                              disabled={this.state.check_modal_type === 2}
                                            >
                                              <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                              Chosse File
                                            </label>
                                            {this.state.leave_loader === false ? (
                                              this.state.check_modal_type === 0 ? (
                                                <button type="button"
                                                  className="btn btn-success btn-label waves-effect waves-light"
                                                  style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(false)}
                                                  disabled={!this.state.leave_type_id || !this.state.employee_id}
                                                >
                                                  <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                  Apply
                                                </button>

                                              ) : this.state.check_modal_type === 1 ? (
                                                <button type="button" className="btn btn-success btn-label waves-effect waves-light" style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(true)}>
                                                  <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                  Update
                                                </button>
                                              ) : <></>
                                            ) :
                                              <>
                                                <button type="button" className="btn btn-success disabled" style={{ height: "50px" }}><i className="spinner-grow fs-15" /></button>

                                              </>
                                            }

                                          </div>

                                          <input
                                            type="file"
                                            id="employee_leave_document"
                                            key={this.state.theInputKey || ""}
                                            onChange={this.handleFileChange}
                                            style={{ marginTop: "10px", display: "none" }}
                                            accept="image/jpeg, image/png, application/pdf"
                                          />
                                          {errors.required_document && <div className="text-danger">{errors.required_document}</div>}
                                          <ul
                                            className="list-unstyled mb-0"
                                            id="dropzone-preview"
                                            style={{ display: this.state.fileName === "" ? "none" : "block", }}>
                                            <li className="mt-2 dz-processing dz-error dz-complete"
                                              id="dropzone-preview-list">
                                              <div className="border rounded">
                                                <div className="d-flex p-2">
                                                  <div className="flex-shrink-0 me-3">
                                                    <div className="avatar-sm bg-light rounded">
                                                      <i className={this.state.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i>
                                                    </div>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                      <h5
                                                        className="fs-13 mb-1"
                                                        data-dz-name=""
                                                      >
                                                        {this.state.fileName}
                                                      </h5>
                                                      <p className="fs-13 text-muted mb-0"
                                                        data-dz-size="">
                                                        <strong>{this.state.fileSize}</strong>
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                    <button
                                                      type='button'
                                                      data-dz-remove=""
                                                      onClick={this.handleDeleteImage}
                                                      className="btn btn-sm btn-outline-danger"
                                                    >
                                                      <i className="ri-delete-bin-line"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div className=" mt-3">
                        <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} >
                          <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                            <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                              <tr>
                                {/* <th style={{ width: "2%" }} >Select</th> */}
                                {this.state.rows?.length > 0 && this.state.admin_access_leave_module == "1"  ?
                                  <th style={{ width: "10%" }}>
                                    <div className=" d-flex gap-1 align-items-center justify-content-center" >
                                      <input
                                          type="checkbox"
                                          className="form-check-input cursorPointer"
                                          // disabled={this.state.loadingPost}
                                          // checked={this.state.selectedRows.length === this.state.rows.length}
                                          checked={
                                            this.state.selectedRows.length > 0 &&
                                            this.state.selectedRows.length ===
                                              (this.state.rows.employee_leave_status == "0").length
                                          }
                                          onChange={this.handleSelectAll}
                                      />
                                        Select {this.state.selectedRows?.length>0 && <span className=' text-white'>({this.state.selectedRows?.length})</span>}
                                    </div>
                                  </th> : null
                              }
                                <th>Employee Code</th>
                                <th>Employee Name</th>
                                <th>Application Date</th>
                                <th>Leave Type</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>Before Balance</th>
                                <th>Leaves Days</th>
                                <th>After Balance</th>
                                <th className=" text-center">Leaves Status</th>
                                {/* <th>Approved By</th> */}
                                {(this.state.decodedData?.includes(1) ) && (  
                                <th className=" text-center">Leaves Details</th>)}
                                { (this.state.decodedData?.includes(3) ) && this.state.admin_access_leave_module == "1" &&(   
                                <th className=" text-center">Action</th>)}
                              </tr>
                            </thead>
                            {this.state.rows.length === 0 ? (
                              <tbody>
                                <tr>
                                  <td colSpan={11}>
                                    <NoRecords />
                                  </td>
                                </tr>
                              </tbody>
                            ) : (
                              <tbody>
                                {this.state.rows.map((row) => (
                                  <tr key={row.employee_leave_id}>
                                   {this.state.rows?.length > 0 && this.state.admin_access_leave_module == "1"  && (
                                    <td>
                                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <input
                                          type="checkbox"
                                          className={` ${row.employee_leave_status !== 0
                                            ? `bg-${row.employee_leave_status_class}`
                                            : ''
                                            } form-check-input`}
                                          checked={this.state.selectedRows.some(
                                            (selectedRow) =>
                                              selectedRow.employee_id === row.employee_id &&
                                              selectedRow.employee_leave_id === row.employee_leave_id
                                          )}
                                          onChange={() => this.handleCheckboxChange(row.employee_id, row.employee_leave_id)}
                                          disabled={row.employee_leave_status !== 0}
                                        />
                                      </div>
                                    </td>)}
                                    <td className=" noWrap text-center">{row.employee_code}</td>
                                    <td>{row.employee_name}</td>
                                    <td className=" noWrap text-center">{formatDate(row.leave_application_date)}</td>
                                    <td>{row.heads_labels[0].concatenated_data}</td>
                                    <td className=" noWrap text-center">{formatDate(row.employee_leave_from_date)}</td>
                                    <td className=" noWrap text-center">{formatDate(row.employee_leave_to_date)}</td>
                                    <td>{row?.employee_leave_balance_before || "--"}</td>
                                    <td>{row.employee_leave_days} <span>{row.employee_leave_days <= 1 ? " day" : " days"}</span></td>
                                    <td>{row?.employee_leave_balance_after || "--"}</td>
                                    <td className=" text-center">
                                      <span className={`badge bg-${row.employee_leave_status_class}`}>
                                        {row.employee_leave_status_label}
                                      </span>
                                    </td>
                                    {(this.state.decodedData?.includes(1) ) && (  
                                    <td>
                                      <div className=" d-flex justify-content-center align-items-center gap-1">
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary"
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModalPopovers"
                                          onClick={() => this.GetLeaveReports(row.employee_leave_id, row.employee_id)}
                                        >
                                          Details
                                        </button>
                                      </div>
                                    </td>)}
                                    {(this.state.decodedData?.includes(3) ) && this.state.admin_access_leave_module == "1" && (
                                    <td style={{ display: 'flex', justifyContent: 'space-around' }}>
                                      <button
                                        onClick={() => this.LeaveAction(row.employee_id, row.employee_leave_id, 2)}
                                        type="button"
                                        className={`${row.employee_leave_status === 0 && this.state.selectedRows.length === 0
                                          ? ''
                                          : 'disabled'
                                          } btn btn-success btn-sm m-1 `}
                                      >
                                        Approve
                                      </button>
                                      <button
                                        onClick={() => this.LeaveAction(row.employee_id, row.employee_leave_id, 1)}
                                        type="button"
                                        className={`${(row.employee_leave_status === 0 || row.employee_leave_status === 2) &&
                                          this.state.selectedRows.length === 0
                                          ? ''
                                          : 'disabled'
                                          } btn btn-danger btn-sm m-1 `}
                                      >
                                        Reject
                                      </button>
                                    </td>)}
                                  </tr>
                                ))}
                              </tbody>
                            )}

                          </table>
                        </div>
                        <div className=" d-flex bg-light justify-content-between align-items-center w-100 p-2">
                          <button
                            disabled={this.state.prev === false && this.state.loadingList === false}
                            type="button"
                            onClick={() => this.handlePrev()}
                            className="btn btn-warning btn-label waves-effect waves-light"
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                            Previous
                          </button>
                          <div
                            className="col-md-4"
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <small>
                              Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}
                            </small>
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-select"
                              onChange={(e) => this.handleChange(e)}
                            >
                              {Array.from({ length: this.state.total_pages }, (_, i) => (
                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                  Page {i + 1}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-2">
                            <select
                              className="form-select"
                              onChange={this.handleLimitChange}
                              value={this.state.limit}
                            >
                              {limitOptions.map((option) => (
                                <option key={option} value={option}>
                                  Limit {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <button
                            disabled={this.state.next === false && this.state.loadingList === false}
                            type="button"
                            onClick={() => this.handleNext()}
                            className="btn btn-primary btn-label waves-effect right waves-light"
                          >
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                            Next
                          </button>
                        </div>
                      </div>
                      <div className="modal fade" id="exampleModalPopovers" tabIndex={-1} aria-labelledby="exampleModalPopoversLabel" aria-modal="true">
                        <div className="modal-dialog modal-xl ">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Details</h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                              <div class="card shadow-none">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                  <h6 class="card-title mb-0">{reportrows.employee_name}</h6>
                                  <h6 class="card-title mb-0">
                                    {reportrows.leave_type_name && reportrows.leave_type_name.length > 0 ? reportrows.leave_type_name[0].leave_type_name : 'No Leave Type'}
                                  </h6>
                                  <a href={`${reportrows.employee_leave_document_url}`}
                                    className={`${!reportrows.employee_leave_document_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                    style={{ marginTop: "10px", float: 'right' }}
                                    target="_blank" rel="noopener noreferrer">
                                    {/* <i className="ri-eye-fill label-icon align-middle fs-16 me-2" /> */}
                                    View Uploaded Document
                                  </a>
                                </div>
                                <div class="card-body">
                                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="">From :{formatDate(reportrows.employee_leave_from_date)}
                                      <div><span className="text-muted mt-2">{reportrows.employee_leave_from_day_unit}</span></div>
                                    </h6>
                                    <h6 class="">To :{formatDate(reportrows.employee_leave_to_date)}
                                      <div><span className="text-muted mt-2">{reportrows.employee_leave_to_day_unit}</span></div>
                                    </h6>
                                    <h6 class="">Total Leave days :{reportrows.employee_leave_days}</h6>
                                  </div>
                                </div>
                                <div class="card-footer d-flex justify-content-between align-items-center flex-wrap">
                                  <div className="">
                                    <span class="">Leave Reason</span>
                                    <p class="card-text text-muted mb-0">{reportrows.employee_leave_reason || "No Reason"}</p>
                                  </div>
                                  <span className={`badge bg-${reportrows.employee_leave_status_class}`}>{reportrows.employee_leave_status_label}</span>
                                </div>
                              </div>

                              <div className="my-3">
                                <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>

                              </div>
                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }} >
                              <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                  <tr>
                                    <th>Action Date</th>
                                    <th>Action By</th>
                                    <th>Leave Type</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th className=" text-center">Total Leave Days</th>
                                    <th>Reason</th>
                                    <th>Remark</th>
                                    <th>Status</th>

                                  </tr>
                                </thead>
                                <tbody>
                                  {log_rows.map((row) => {
                                    var leave_obj = JSON.parse(row.leave_apply_object);
                                    return (
                                      <tr key={row.employee_leave_log_id}>
                                        <td>{formatDate(row.created_date)}</td>
                                        <td>{row.created_by_name}</td>
                                        <td>{leave_obj.leave_type_name}</td>
                                        <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                        <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                        <td className=" text-center">{leave_obj.employee_leave_days}</td>
                                        <td className={`${leave_obj?.employee_leave_reason?.length >= 30 ? "textEllipse" : "noWrap"}`}>{leave_obj?.employee_leave_reason}</td>
                                        <td className={`${row?.remark?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row?.remark}</td>
                                        <td ><span className={`badge bg-${row?.employee_leave_log_status_class}`}>{row?.employee_leave_status_label}</span></td>
                                      </tr>
                                    )
                                  })}

                                </tbody>
                              </table>
                            </div>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-light" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>) : <div>
          <Loader />
        </div>
    );
  }
}
export default withRouter(ApprovedLeave);
